import React from 'react';
export const UrgencyBar = () => {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#ADFF2F] text-black font-bold text-xs sm:text-sm py-2.5 px-4 shadow-lg" data-id="element-244">
      <div className="container mx-auto flex items-center justify-center text-center flex-wrap gap-x-2" data-id="element-245">
        <span className="whitespace-nowrap" data-id="element-246">
          🔥 OFERTA DE LANZAMIENTO: Solo por hoy $6.39 USD — Precio sube a $27
          el viernes
        </span>
        <span className="hidden sm:inline" data-id="element-247">·</span>
        <span className="whitespace-nowrap" data-id="element-248">
          ⚡ Acceso inmediato al descargar
        </span>
      </div>
    </div>;
};